module.exports = __webpack_public_path__ + "img/Advanced Search - Blue.132fe393.png";